import React from 'react';
import { StyledImage, StyledWrapper } from './style';
import gymPass from '../../../../assets/images/png/bienestara3mil.png';
// import { API_SOCIAL } from '../../../constants/api';
// import request from '../../../utils/api';

// let image = '';

// const getImageURL = params =>
//   request(`${API_SOCIAL}widget/home`, {
//     params,
//     method: 'GET'
//   }).then(response => {
//     response.map(el => {
//       if (el.type === 'md3') {
//         image = el.icon;
//       }
//       return image;
//     });
//   });
//
// getImageURL();

const Gympass = () => (
  <StyledWrapper>
    <StyledImage src={gymPass} />
  </StyledWrapper>
);

export default Gympass;
